import Component from '@Component';

export default class VanOrderForm extends Component {
  static selector = '[data-comp-van-order-form]'

  constructor(containerEl) {
    super(containerEl);
    this.vehicleTypeField = this.$container.querySelector('[data-vehicle-type-field]');
    this.vehicleTypeOptions = this.vehicleTypeField.querySelectorAll('input');
    this.colorOptions = this.$container.querySelectorAll('[data-color-option]');
    this.vehicleAdditions = this.$container.querySelectorAll('[data-vehicle-addition]');
    this.init();
  }

  init() {
    this.determineVehicleType();
    this.addVehicleTypeChangeListener();
  }

  determineVehicleType() {
    this.vehicleTypeOptions.forEach(option => {
      if (!option.checked) {
        return;
      }
      this.updateVehicleOptions(this.colorOptions, `data-${option.dataset.vehicle}-color`, true);
      this.updateVehicleOptions(this.vehicleAdditions, `data-${option.dataset.vehicle}-vehicle-addition`, false);
    });
  }

  addVehicleTypeChangeListener() {
    this.vehicleTypeField.addEventListener('change', () => {
      this.determineVehicleType();
    });
  }

  updateVehicleOptions(options, vehicleType, checkFirstOption = false) {
    options.forEach(item => {
      const option = item;
      if (!option.hasAttribute(vehicleType)) {
        option.style.display = 'none';
        removeCheckedStatus(option);
      } else {
        option.style.display = null;
      }
    });
    if (checkFirstOption) {
      addCheckedToFirstOption(this.colorOptions);
    }
  }
}

function removeCheckedStatus(option) {
  const input = option.querySelector('input');
  if (input.checked) {
    input.checked = false;
  }
}

function addCheckedToFirstOption(options) {
  let optionChecked = false;
  options.forEach(item => {
    const option = item;
    if (optionChecked === false && option.style.display !== 'none') {
      option.querySelector('input').checked = true;
      optionChecked = true;
    }
  });
}
